import { Component, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { Router } from '@angular/router';
//import { MenuItem } from 'primeng/api/menuitem';
import { MenuItem } from 'primeng/api';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';
import { SessionService } from 'src/app/auth/services/session.service';
import { MenuService } from './menu.service';

@Component({
  selector: 'panel-menu',
  templateUrl: './panel-menu.component.html',
  styleUrls: ['./panel-menu.component.scss'],
  standalone: false,
})
export class PanelMenuComponent implements OnChanges, OnInit {
  public authorizationService = inject(AuthorizationService);
  protected sessionService = inject(SessionService);
  private menuService = inject(MenuService);

  private router = inject(Router);
  protected menu: MenuItem[] = [];
  protected loggedInOrg!: string;

  ngOnInit(): void {
    this.sessionService.session.subscribe((session) => {
      this.updateMenuVisibilities();
      this.loggedInOrg =
        this.sessionService
          .anvandarOrganisationer()
          .find((org) => org.organisationId === this.sessionService.session.getValue()?.org_id)?.organisation ?? '';
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    changes['menu'] && this.setMenuItemCommandFunction(this.menu);
  }

  private setMenuItemCommandFunction = (menu: MenuItem[]): void => {
    menu?.forEach((menuItem) => {
      if (!menuItem.command && menuItem.state?.['isSubMenuItem']) menuItem.command = this.commandFn.bind(this);
      menuItem.items && this.setMenuItemCommandFunction(menuItem.items);
    });
  };

  private commandFn(e: any) {
    this.router.navigate([e.item.routerLink]);
  }

  private updateMenuVisibilities() {
    this.menu = this.menuService.menuSections();
  }
}
